/**
 * Offline — нет интернета. Auto-retry когда `online` event сработал.
 */
import { useEffect, useState } from 'react'
import { ErrorLayout, ErrorBlock } from '@/components/layout/ErrorLayout'
import { Button } from '@/components/ui/Button'

export function Offline() {
  const [retrying, setRetrying] = useState(false)

  useEffect(() => {
    const onOnline = () => window.location.reload()
    window.addEventListener('online', onOnline)
    return () => window.removeEventListener('online', onOnline)
  }, [])

  return (
    <ErrorLayout hideBack>
      <ErrorBlock
        icon="wifi-off"
        iconTone="muted"
        title="Нет интернета 📡"
        body={
          <p>
            Проверь подключение к Wi-Fi или мобильной сети. Мы автоматически перезагрузим страницу, как только связь появится.
          </p>
        }
        actions={
          <Button
            variant="primary"
            loading={retrying}
            onClick={() => {
              setRetrying(true)
              window.location.reload()
            }}
          >
            Попробовать снова
          </Button>
        }
      />
    </ErrorLayout>
  )
}
